namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItemService {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItemRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItemRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem/Create",
            Update = "AdvPromo/PsAdvPromoItem/Update",
            Delete = "AdvPromo/PsAdvPromoItem/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem/Retrieve",
            List = "AdvPromo/PsAdvPromoItem/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItemService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
